var render = function () {
  var _vm$blockchain;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('header', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s((_vm$blockchain = _vm.blockchain) === null || _vm$blockchain === void 0 ? void 0 : _vm$blockchain.name) + " DETAILS")])]), _vm.blockchain ? _c('section', {
    staticClass: "card"
  }, [_c('Metadata', {
    attrs: {
      "blockchain": _vm.blockchain
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }